import React from "react";
import SocialMedia from "./SocialMedia";
import SitemapColumn from "./SitemapColumn";

const Sitemap = () => (
  <ul className="grid grid-cols-2 lg:grid-cols-3 gap-y-20 grid-in-sitemap w-full mt-[27px] lg:mt-[59px]">
    {/* @ts-ignore */}
    <SitemapColumn section={window.WANTABLE_footer.footerLinks.section1} />

    {/* @ts-ignore */}
    <SitemapColumn section={window.WANTABLE_footer.footerLinks.section2} />

    {/* @ts-ignore */}
    <SitemapColumn section={window.WANTABLE_footer.footerLinks.section3} />

    <li className="md:hidden">
      <p className="text-desktop-heading-6 font-bold">Socials</p>

      <ul className="flex flex-col mt-20">
        <SocialMedia />
      </ul>
    </li>
  </ul>
);

export default Sitemap;
